var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.012 13.477c0 .537.341.684.76.33l5.912-5.16a.812.812 0 0 0 0-1.284l-5.912-5.17c-.42-.355-.76-.206-.76.33V6h-1c-3.82 0-7.087 3.166-7.883 6.586-.059.254-.1.511-.125.77-.03.268.1.327.291.139 0 0 .054-.048.1-.1a11.46 11.46 0 0 1 7.62-3.4h1l-.003 3.483Z",
    clipRule: "evenodd"
  })));
};
export default SvgShare;